import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject, input } from '@angular/core';
import { buyDownType } from 'apps/cmg-clear2-ui/src/app/cmg-1003/models/lookups/property-info.lookups';
import { Cmg1003LoanQuery } from 'apps/cmg-clear2-ui/src/app/loan-state/loan/loan.query';
import { spaceOutCamelCase } from '../../../utils';
import { Loan1008Model } from 'apps/cmg-clear2-ui/src/app/loan-1008/models/loan-1008.model';
import { Loan1008Service } from 'apps/cmg-clear2-ui/src/app/loan-1008/loan-1008.service';
import { take } from 'rxjs';
import { amortizationTypeOptions, mortgageAppliedForOptions, purposeOfLoanOptions } from 'apps/cmg-clear2-ui/src/app/cmg-1003/models';
import { subFiTypes } from 'apps/cmg-clear2-ui/src/app/cmg-1003/models/lookups/expenses.lookups';
import { Panel } from 'primeng/panel';
import { PrimeTemplate } from 'primeng/api';
import { AsyncPipe, PercentPipe, CurrencyPipe } from '@angular/common';
import { EmptyToDashPipe } from '../../../pipes/empty-to-dash.pipe';
import { ToNameOrValueNoSelectPipe } from '../../../pipes/to-name-no-select.pipe';
import { YesNoPipe } from '../../../pipes/to-yesno.pipe';
import { InfoPanelContentComponent } from '../components/info-panel-content/info-panel-content.component';
import { InfoRowComponent } from '../components/info-row/info-row.component';

@Component({
  selector: 'cmg-mortgage-information',
  templateUrl: './mortgage-information.component.html',
  styleUrls: ['./mortgage-information.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    Panel,
    PrimeTemplate,
    AsyncPipe,
    PercentPipe,
    CurrencyPipe,
    EmptyToDashPipe,
    ToNameOrValueNoSelectPipe,
    YesNoPipe,
    InfoPanelContentComponent,
    InfoRowComponent,
  ],
})
export class MortgageInformationComponent implements OnInit {
  private readonly _loan1008Service = inject(Loan1008Service);
  private readonly _cdRef = inject(ChangeDetectorRef);
  private readonly _loanQuery = inject(Cmg1003LoanQuery);

  readonly fileDataId = input<number>(undefined);
  loan1008Data: Loan1008Model;

  loanInfo$ = this._loanQuery.selectLoanInfo();
  amortizationTypeOptions = amortizationTypeOptions;
  buyDownType = buyDownType;
  mortgageAppliedForOptions = mortgageAppliedForOptions;
  purposeOfLoanOptions = purposeOfLoanOptions;
  subFiTypes = subFiTypes;

  ngOnInit(): void {
    if (this.fileDataId() > 0) {
      this._loan1008Service
        .getLoan1008data(this.fileDataId())
        .pipe(take(1))
        .subscribe((loan1008Data) => {
          this.loan1008Data = loan1008Data;
          this._cdRef.detectChanges();
        });
    }
  }

  getMatchString(str) {
    return this._isStringExcluded(str) ? '-' : spaceOutCamelCase(str);
  }

  private _isStringExcluded(input: string): boolean {
    const excludeValues = ['select', 'notassigned'];
    const lowerCaseString = input.toLowerCase();
    const stringWithoutSpaces = lowerCaseString.replace(/\s/g, '');
    return excludeValues.includes(stringWithoutSpaces);
  }
}
